module.exports = __webpack_public_path__ + "static/media/poly-grid-left.a4ebb83a.svg";